import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { GatePass } from 'src/app/_models/gate_pass';
import { Guardian } from 'src/app/_models/guardian';
import { AdminService } from 'src/app/_services/admin.service';
import { AuthService } from 'src/app/_services/auth.service';
import { UserService } from 'src/app/_services/user.service';

@Component({
  selector: 'app-user-edit-access',
  templateUrl: './user-edit-access.component.html',
  styleUrls: ['./user-edit-access.component.css']
})
export class UserEditAccessComponent implements OnInit {
  roleGroups =[]
  user = undefined
  userEditForm :FormGroup
  guardian= new Guardian()
  update_success=false
  gatePass:GatePass=new GatePass()
  checkedTickets=[]
  isSaving=false
  errorSaving=false
  constructor(
    private route:ActivatedRoute,
    private userService:UserService,
    public authService:AuthService,
    private adminService:AdminService) { }
  get f(){
    return this.userEditForm.controls
  }
  ngOnInit(): void {
    this.route.params.subscribe(
      x=>{
        this.userService.getById(x['server_user_id']).subscribe(
         {
          next:(xxx) =>{
            this.user=xxx.rs.data
            this.roleGroups = this.user['roleGroups']
            this.initForm()
            this.initCheckedGroups()
          }
         }
        )
      }
    )

    this.authService.gatePass.subscribe(
      gatePass=>{
        this.gatePass=gatePass
      }
    )
  }
  initForm(){
    this.userEditForm = new FormGroup({
      'rgName': new FormControl('', [Validators.required])
    });

  }


  isChecked(gg:any){
    return gg['is_in']==1
  }


  onCheck(evt) {

    if (!this.checkedTickets.includes(evt)) {
      this.checkedTickets.push(evt);
    } else {
      var index = this.checkedTickets.indexOf(evt);
      if (index > -1) {
        this.checkedTickets.splice(index, 1);
      }
    }

  }
  removeItemFromArray(fact_id:number, fList:Array<any>){
    let index=0
    for( let i =0; i < fList.length;i++){
      if(fact_id == fList[i].id){
        index=i
        fList.splice(index,1)
        break
    }
  }
  }

  initCheckedGroups(){
    for(let gg of this.user.roleGroups){
      if(this.isChecked(gg)){
        this.checkedTickets.push(gg['id'])
      }
    }
  }


  on_submit(){
   this.isSaving=true
   let dd=this.formatData()

   this.adminService.updatePermissions(dd).subscribe(
     val=>{
       this.isSaving=true
       if(val['server_user_id']==0){
        this.errorSaving=true
       }
       else{
        this.user=val
       }
       this.isSaving=false
     }
   )

 }
 formatData(){
   let data = new URLSearchParams();

   data.set('id', this.user.server_user_id.toString());

   for(let i=0; i < this.checkedTickets.length;i++){
     data.append('groups', this.checkedTickets[i].toString());
   }

   return data.toString()
 }
}
